import styled from 'styled-components';
import { StyledTextbox } from '../../commonComponents/Textbox/Textbox.style';
import { Search } from "@mui/icons-material";

const textField = (theme: any) => `
  width: 314px;
  border-radius: 64px;
  background-color: ${theme.uptimeColors.grayScales.white};
  margin-top: ${theme.uptimeSpace[0]};
  transition: width 1s;
  height: 40px;
  border: 1px solid ${
    theme.uptimeColors.menuColors.mainMenu?.searchBorder
      ? theme.uptimeColors.menuColors.mainMenu?.searchBorder
      : "unset"
  } !important; 

  @media (min-width: 1200px) {
    width: 250px;
    height: 38px; 
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiInputBase-root {   
    padding: 0 ${theme.uptimeSpace[6]}px;
    display: flex;
    align-items: center;
    font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    font-family: ${theme.uptimeFonts.primary};
    height: 100%;
    .MuiInputBase-input {
      color: ${theme.uptimeColors.textColors.primary};
      height: 20px;
      padding: ${theme.uptimeSpace[0]};
      margin: ${theme.uptimeDynamicAlignCenter?.searchBoxHomePage?.marginTop ?? `${theme.uptimeSpace[7] + 1}px`} ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[7] + 1}px;
    }  
    .MuiIconButton-root {
      padding: ${theme.uptimeSpace[0]};
      &:hover {
        background-color: inherit !important;
      }
      &:focus {
        background-color: #c2d0d5 !important;
      }
    }
  }  
`;

export const StyledSearchIcon = styled(Search)`
  ${({ theme }) => `
  color: ${theme.uptimeColors.menuColors.mainMenu?.searchIcon ? theme.uptimeColors.menuColors.mainMenu?.searchIcon : theme.uptimeColors.generalColors.icon.enabled} !important;
`}
`;

export const StyledSearch = styled(StyledTextbox)`
  ${({theme})=>`

  &.default-search {
    width: 100%;
    background-color: ${theme.uptimeColors.grayScales.white};
    margin-top: ${theme.uptimeSpace[0]};    
    border: 1px solid rgba(0, 0, 0, 0.5) !important;
    .MuiOutlinedInput-notchedOutline {
      border: none
    }
  }

  &.textField {
    ${textField(theme)}
  }

  &.active-search {
    ${textField(theme)}
    width: 350px;
    @media (min-width: 1200px) {
      width: 314px;
    } 
  }

  .forwardIconWithGrayColor {
    color: ${theme.uptimeColors.grayScales.gray};
  }
  .forwardIconWithBlueColor {
    color: ${theme.uptimeColors.mainTheme.primary};
  }

  .startIcon,
  .endIcon {
    color: ${theme.uptimeColors.mainTheme.primary};
    width: 24px;
  }
  .startIcon {
    margin-right: ${theme.uptimeSpace[8]}px;
  }
  `} 
`;